import { fetchQuery } from "@/lib/GraphQLCodegen/fetcher";
import {
  RelocationRecord,
  relocationRecordQuery,
} from "@/app/Relocations/GraphQL/relocationRecordQuery";
import { getRelocationViewsVariables } from "@/app/Relocations/Utils/getRelocationViewsVariables";
import { getRelocationUpdateInput } from "@/app/Relocations/Utils/getRelocationUpdateInput";
import { relocationViewCountListQuery } from "@/app/Relocations/GraphQL/relocationViewCountListQuery";
import { vehiclePurchasableExtrasQuery } from "@/app/Vehicles/GraphQL/vehicleRecordQuery";
import { purchasableExtrasQuery } from "@/app/Suppliers/GraphQL/supplierPurchasableExtrasQuery";
import { supplierRecordQuery } from "@/app/Suppliers/GraphQL/supplierRecordQuery";
import { supplierInsuranceOptionListQuery } from "@/app/Suppliers/GraphQL/supplierInsuranceOptionListQuery";
import {
  supplierOfficeListQuery,
  supplierOfficeListVariables,
} from "@/app/Offices/GraphQL/supplierOfficeListQuery";
import { supplierOfficeRecordQuery } from "@/app/Offices/GraphQL/supplierOfficeRecordQuery";
import { supplierTripByOfficesQuery } from "@/app/SupplierTrips/GraphQL/supplierTripRecord";
import { tripByCities } from "@/app/Cities/Trips/GraphQL/tripByCities";
import { RelocationType } from "@/gql/graphql";

export async function loadRelocationDetails(
  relocationId: string,
  orgId: string,
) {
  const { relocation } = await fetchQuery(
    relocationRecordQuery,
    { id: relocationId },
    orgId,
  );

  if (!relocation) {
    return;
  }

  const supplierId = relocation.supplier.id;

  await Promise.all([
    fetchQuery(
      relocationViewCountListQuery,
      getRelocationViewsVariables(relocationId, "week"),
      orgId,
    ),
    fetchQuery(
      vehiclePurchasableExtrasQuery,
      { vehicleId: relocation.vehicle.id },
      orgId,
    ),
    fetchQuery(
      purchasableExtrasQuery,
      { first: 200, page: 1, supplierId },
      orgId,
    ),
    relocation.type === RelocationType.GapRental
      ? null
      : loadRelocationFormQueries(relocation, orgId),
  ]);
}

async function loadRelocationFormQueries(
  relocation: RelocationRecord,
  orgId: string,
) {
  const supplierId = relocation.supplier.id;
  const departureOfficeId = relocation.departureOffice.id;
  const [deliveryOfficeId, ...additionalOfficeIds] =
    getRelocationUpdateInput(relocation).deliveryOfficeIds;

  await Promise.all([
    fetchQuery(supplierRecordQuery, { id: supplierId }, orgId),
    fetchQuery(
      supplierInsuranceOptionListQuery,
      { supplierId, page: 1, first: 20 },
      orgId,
    ),
    fetchQuery(
      supplierOfficeListQuery,
      supplierOfficeListVariables(supplierId),
      orgId,
    ),
    ...[
      departureOfficeId,
      deliveryOfficeId,
      ...additionalOfficeIds.slice(0, 3),
    ].map((id) => fetchQuery(supplierOfficeRecordQuery, { id }, orgId)),
    fetchQuery(
      supplierTripByOfficesQuery,
      { officeAId: departureOfficeId, officeBId: deliveryOfficeId },
      orgId,
    ).then(({ supplierTripByOffices }) => {
      const cityAId = supplierTripByOffices?.officeA?.city?.id;
      const cityBId = supplierTripByOffices?.officeB?.city?.id;

      return cityAId && cityBId
        ? fetchQuery(tripByCities, { cityAId, cityBId }, orgId)
        : null;
    }),
  ]);
}
